import React, {useState, useEffect, useContext} from 'react';
import { AuthContext } from '../auth/AuthContext';
import {BusyContainer} from "./BusyContainer";
import {CategoryViewer} from "./CategoryViewer";
import {CategoryContext, CategoryContextProps} from "./CategoryContext";
import {createFetchRequest} from "../util/fetcher";
import {ArticlePane} from "./ArticlePane";
import {retrieveErrorMessage, useDeepLink} from "../util/utilites";
import {Category} from "../models";
import { useParams } from 'react-router';

export const NavigatorPane: React.FunctionComponent = () => {
    const params = useParams();
    const [getDeeplink, getContext] = useDeepLink();
    const { sessionId } = useContext(AuthContext);
    const [context, setContext] = useState<CategoryContextProps>(getContext('deeplink' in params ? params.deeplink : ''));
    const [categories, setCategories] = useState<Category[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleError = (e: unknown): void => {
      setError(retrieveErrorMessage(e));
    };

    useEffect(() => {
        if (loading || categories.length || error) {
            return;
        }
        setLoading(true);
        void createFetchRequest('api/category/all', sessionId )
            .then( response => {
                if (!response.ok) {
                    setError('Loading data failed');
                    return;
                }
                return response.json();
            }).then( categories => {
                setCategories(categories);
                setLoading(false);
            })
            .catch( handleError );
    }, [sessionId, loading, categories, error]);

    if (loading) {
        return <BusyContainer text="loading categories" />;
    }
    if (error) {
        return <div>{ error }</div>
    }

    const setCurrentContext = (context: CategoryContextProps): void => {
        setContext(context);
        document.location.replace(`#/${getDeeplink(context)}`);
    }

    const updateCurrentCategory = (currentCategory: number) => {
        setCurrentContext({ ...context, currentPage: 0, currentCategory })
    };

    const updateQuery = ( query: string ) => {
        setCurrentContext({
            ...context,
            currentCategory: -1,
            query,
            currentPage: 0
        });
    };

    const setPageSize = ( pageSize: number ) => {
        setCurrentContext({
            ...context,
            pageSize,
            currentPage: Math.floor( context.currentPage * context.pageSize / pageSize )
        })
    };

    const setCurrentPage = (currentPage: number) => {
        setCurrentContext({
            ...context,
            currentPage
        })
    };

    return (
        <CategoryContext.Provider value={{ ...context, setQuery: updateQuery  }}>
            <CategoryViewer categories={categories} currentCategory={context.currentCategory} setCategory={updateCurrentCategory} />
            <ArticlePane setCurrentPage={setCurrentPage} setPageSize={setPageSize} />
        </CategoryContext.Provider>
    );
}